import React from 'react';
import LoadingScreen from '../../LoadingScreen';

export default function FullPageLoader(): React.JSX.Element {
  return (
    <div className='fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden flex flex-col items-center justify-center bg-white'>
      <div style={{ height: '50vh' }}>
        <LoadingScreen />
      </div>
    </div>
  );
}
